import FormInputsProStyle from "../templates/FormInputs.style";
import FormInputsBaseStyle from "../templates/FormInputBase.style";
var inputData = {
  name: 'input',
  data: [{
    radius: 4,
    border: 'all',
    // 边框： all | [bottom, top, left, ...]
    borderWidth: 1,
    borderWidthFocused: 2,
    borderColor: '#D9E6F2',
    fontColor: '#0F1358',
    fontSize: 13,
    disabledBorderColor: '#D9E6F2',
    disabledBgColor: 'rgba(158,173,190,0.04)',
    disabledFontColor: 'rgba(15,19,88,0.25)',
    inputHeight: 32,
    inputFontWeight: '500',
    background: '#fff',
    // Form
    // labelAlign: 'left',
    formInputHeight: 50,
    formInputOtherHeight: 34,
    labelFontSize: 13,
    labelBackGround: 'transparent',
    baseLabelFontColor: 'rgba(15,19,88,0.65)',
    emptyLabelFontColor: '#9EADBE',
    focusedLabelFontColor: '#5365EA',
    errorShadow: '0 0 3px 0  rgba(253,114,156,0.04)',
    errorColor: '#F76776',
    errorFontColor: '#F76776',
    errorTitleColor: '#F76776',
    errorBgColor: 'rgba(253,114,156,0.04)',
    errorAllBgColor: 'rgba(253,114,156,0.04)',
    errorFocusBorderbottom: '.02rem solid #FD729C',
    labelCol: 24,
    formCol: 24,
    focusedBorderColor: '#5365EA',
    focusBordertop: 'none',
    focusBorderbottom: '.02rem solid #5365EA',
    focusBorderleft: 'none',
    focusBorderright: 'none',
    groupAddonBackground: 'rgba(158,173,190,0.06)',
    groupAddonPadding: '0rem 0.04rem',
    groupAddonBorder: '.01rem solid #D9E6F2',
    floatMargin: '0 0 .2rem 0',
    floatCloseIcon: '\\E5C9',
    floatCloseIconHoverColor: '#9EADBE',
    floatMutipleItemBackground: '#rgba(83,101,234,0.08)',
    floatMutipleItemColor: '#415BC9',
    cursorBackgroundColor: 'transparent',
    textAndMutiplePaddingTop: '.15rem',
    mutiplePaddingLeft: '.04rem',
    mutipleBorderRadius: '.05rem',
    mutipleInputPaddingTop: '0rem',
    selectPaddingLeft: '.1rem',
    inputPaddingTop: '.20rem',
    mutipleIconColor: '#415BC9',
    mutipleErrorBgColor: 'rgba(253,114,156,0.1)',
    floatLabelWith: 'auto',
    floatLabelTop: '.15rem',
    floatLabelLeft: '.03rem',
    floatLabelMarginLeft: '0',
    floatLabelMarginTop: '0',
    floatPrefixLeft: '.24rem',
    floatTextAreaPadding: '0',
    floatTextAreaPosition: 'relative',
    floatTextAreaTop: '.12rem',
    floatNumberInputButtonIconVertical: 'sub',
    floatLableMutipleRangeHeight: '.24rem',
    PrefixSuffixColor: '#ABBCCF',
    numberInputButtonMargin: '0',
    numberInputButtonHeight: '100%',
    numberInputButtonTop: '0',
    numberInputButtonRight: '0',
    numberInputButtonIconHeight: '50%',
    numberInputButtonHeightItem: '.24rem',
    numberInputButtonIconBorder: '1px solid #D9E6F2',
    numberInputButtonIconColor: '#5365EA',
    numberInputButtonIconMargin: '0',
    numberInputButtonIconBorderRight: 'none',
    numberInputButtonIconBorderFirstTop: 'none',
    numberInputButtonIconBorderLastBottom: 'none',
    rangeSplitPaddingTop: '.2rem'
  }, {
    layout: 'horizontal',
    radius: 2,
    border: 'all',
    // 边框： all | [bottom, top, left, ...]
    borderWidth: 1,
    borderColor: 'rgba(0,0,0,0.15)',
    fontSize: 12,
    disabledBorderColor: '#D9E6F2',
    disabledBgColor: 'rgba(158,173,190,0.04)',
    disabledFontColor: 'rgba(15,19,88,0.25)',
    inputHeight: 30,
    inputFontWeight: 'bold',
    background: '#fff',
    // Form
    // labelAlign: 'right',
    labelFontSize: 12,
    labelFontColor: '#4A5C90',
    focusedLabelFontColor: '',
    errorShadow: '0 0 3px 0  rgba(253,114,156,0.04)',
    errorColor: '#FD6868',
    errorFontColor: '#BFC3D0',
    errorBgColor: ' rgba(253,114,156,0.04)',
    labelCol: 8,
    formCol: 16
  }],
  onlyTemplate: {
    pro: FormInputsProStyle,
    base: FormInputsBaseStyle
  }
};
export default inputData;